import { IKnoOrganizationDictionary } from 'APIPackage/DictionariesModule/interfaces/IKnoOrganizationDictionary';
import { IDictionarySelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySelectOption';
import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';

export function convertFilterDataToControlOrganizationsIds<T extends { id: ISelectOption['id'] }>(
  options: IDictionarySelectOption<IKnoOrganizationDictionary>[] | undefined,
  data?: T[],
): string[] | undefined {
  return options
    ?.filter(item => data?.find(organization => organization.id.toString() === item.id.toString()))
    .map(item => item.value.dictVersionId);
}
